
export function IsOnGreenSide(): boolean {
    return window.ETDR_RD.appConfig['Info.IsOnGreenSide'];
}
